import { type FC, useState } from 'react';

import {
  Button,
  Dialog,
  DialogActionButtons,
  DialogContent,
  DialogContentText,
  DialogHeading,
  DialogTrigger,
  Modal,
} from '@iconik-io/uad';

import styles from './segment_keyframe.module.css';

type Props = {
  url: string;
};

export const SegmentKeyframe: FC<Props> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  return (
    <DialogTrigger>
      <Button
        className={styles.keyframe}
        variant="tertiary"
        onPress={() => setIsOpen(true)}
      >
        <img src={props.url} alt="Attached keyframe" />
      </Button>
      <Modal isDismissible isOpen={isOpen} onOpenChange={setIsOpen}>
        <Dialog>
          <DialogHeading isDismissible>Attached keyframe</DialogHeading>
          <DialogContent>
            <img
              src={props.url}
              alt="Attached keyframe enlarged view"
              onLoad={() => setIsImageLoaded(true)}
              style={{ display: isImageLoaded ? 'block' : 'none' }}
            />
            {!isImageLoaded && (
              <DialogContentText>Loading...</DialogContentText>
            )}
          </DialogContent>
          <DialogActionButtons>
            <Button
              variant="primary"
              size="l"
              onPress={() => {
                const link = document.createElement('a');
                link.href = props.url;
                link.download = '';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setIsOpen(false);
              }}
            >
              Download
            </Button>
          </DialogActionButtons>
        </Dialog>
      </Modal>
    </DialogTrigger>
  );
};
